<template>
  <el-drawer title="使用期限修改" v-model="visible" destroy-on-close>
    <el-form label-width="100px" class="enterprise-approval-form">
      <el-alert title="企业信息" type="info" :closable="false" />
      <el-form-item label="企业名称:">
        <div v-text="enterprise.fullName"></div>
      </el-form-item>
      <el-form-item label="企业简称:">
        <div v-text="enterprise.name"></div>
      </el-form-item>
      
      <el-alert title="管理设置" type="info" :closable="false"></el-alert>
      <el-form-item label="是否长期有效:">
        <el-switch div v-model="info.isEffective" @change="isEffectiveChange"
          active-text="是" inactive-text="否" inline-prompt></el-switch>
      </el-form-item>
      <el-form-item label="有效开始日期:">
        <el-date-picker div type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
          v-model="info.effectiveStartDate"></el-date-picker>
      </el-form-item>
      <el-form-item label="有效结束日期:">
        <el-date-picker div type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
          v-model="info.effectiveEndDate"></el-date-picker>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="enterprise-approval-footer">
        <el-button type="primary" @click="visible = false" :loading="saveLoading">返回</el-button>
        <el-button @click="save" :loading="saveLoading">保存</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { updateEnterpriseEffectiveById } from '@/api/sys/org';
import { defineComponent } from 'vue'

export default defineComponent({
  emits: ['update:modelValue', 'get-data'],
  data() {
    return {
      saveLoading: false,
      info: {}
    }
  },
  props: {
    modelValue: Boolean,
    enterprise: Object
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  watch: {
    enterprise: {
      handler(val) {
        if (val) {
          this.info = {
            id: val.id,
            isEffective: val.isEffective,
            effectiveStartDate: val.effectiveStartDate,
            effectiveEndDate: val.effectiveEndDate,
          }
        }
      },
      deep: true
    }
  },
  methods: {
    isEffectiveChange() {
      this.info.effectiveStartDate = '';
      this.info.effectiveEndDate = '';
    },
    save(auditStatus) {
      let info = this.info;
      if (!info.isEffective) {
        if (!info.effectiveStartDate) {
          this.$message.warning('请选择有效开始日期');
          return;
        }
        if (!info.effectiveEndDate) {
          this.$message.warning('请选择有效结束日期');
          return;
        }

        if (info.effectiveStartDate > info.effectiveEndDate) {
          this.$message.warning('有效结束日期不能小于开始日期');
          return;
        }
      }

      this.saveLoading = true;
      updateEnterpriseEffectiveById(info).then(({data}) => {
        if (data.status) {
          this.$message.success(data.msg);
          this.visible = false;
          this.$emit('get-data')
        } else {
          this.$message.warning(data.msg);
        }
        this.saveLoading = false;
      }).catch(_ => this.saveLoading = false);
    }
  }
})
</script>

<style lang="scss" scoped>
.enterprise-approval-form {
  padding: 20px 20px 0;
  overflow-y: auto;
  .el-alert {
    margin-bottom: 15px;
  }
}
.enterprise-approval-footer {
  width: 100%;
  text-align: center;
}

</style>